<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import useColor from '@/composables/merchant'
import DebugConsole from '@/components/DebugConsole.vue'

const { setThemeColor } = useColor()
const route = useRoute()

const setupFontLink = () => {
  const link = document.createElement('link')
  link.href = `${import.meta.env.VITE_AWS_STORAGE_URL}/fonts/degular/stylesheet.css`
  link.rel = 'stylesheet'
  document.head.appendChild(link)
}

setThemeColor()
setupFontLink()

const isDebugMode = computed(() => route.query.debug === 'true')
</script>

<template>
  <div class="h-full bg-white">
    <suspense>
      <RouterView />
    </suspense>
    <DebugConsole v-if="isDebugMode" />
  </div>
</template>

<style>
html {
  font-size: 16px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}
html,
body {
  @apply h-full;
  font-family: 'degular', sans-serif;
  letter-spacing: -0.3px;
}
li,
span,
button,
input,
optgroup,
select,
textarea {
  font-family: 'degular', sans-serif !important;
  letter-spacing: -0.3px;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}
</style>
